module.exports = __webpack_public_path__ + "img/item_image04.db57a2b0.jpg";